import reply from './reply';
import setstatus from './setstatus';
import preview from './preview';
import forward from './forward';

export default {
  preview,
  setstatus,
  reply,
  forward
}
